import MyPageRoute from "./MyPageRoute";
import mypage_reducer from "./slice";
import mypageSaga, { MYPAGE_SET_BANK_ACCOUNT_SAGA } from "./saga";
import { BillingData, BankAccountData, BankData } from "./interface";

export type { BillingData, BankAccountData, BankData };
export { mypageSaga, mypage_reducer, MYPAGE_SET_BANK_ACCOUNT_SAGA };
export default MyPageRoute;
